module.exports = __webpack_public_path__ + "static/media/od_7 copy.ccba6620.jpg";